//
//
//
//
//
//
//
//
//
//
//
//

import TransitionExpand from '../transitions/Expand.vue'
import {mapGetters} from 'vuex';
export default {
	name: "ProgramHighlights",
	props: ["highlights"],
  components: {
    TransitionExpand
  },
	computed: {
    ...mapGetters(['model', 'search']),
    empty() {
      return this.listing.every(highlight => highlight.visible === false);
    },
    listing() {
      return this.highlights.map((highlight) => {
        let highlightMap = {
          ...this.getData(highlight),
          html: highlight
        }
        highlightMap.visible = this.checkVisibility(highlightMap.category)
        return highlightMap;
      });
    },
	},
  methods: {
    getData(html) {
      const data = {category: null, content: null};
      let item = document.createElement("div");
      item.innerHTML = html.trim();
      item = item.firstChild;
      data.category = JSON.parse(item.dataset.category);
      data.content = item.innerHTML;
      return data;
    },
    checkVisibility(category) {
      const facetMatch = this.model.some(selection => {
        if (!selection) return false;
        else if (category === selection) return true;
      });
      return facetMatch;
    }
	}
}
